/**
 * PaperJournalSummaryCard — REW-929 Phase 3.
 *
 * Renders aggregate counts over the chosen summary window using the same
 * StatCard + statsGrid pattern as Dashboard / BenepassTransferSummary /
 * IncommCardsSummary, so all admin summary surfaces look the same.
 *
 * The summary is filter-independent — it always reflects the entire window
 * the user picked regardless of any uploaded_by / date-range filters on the
 * table.
 */

import React from 'react';
import { StatCard } from '@/components/common/Card';
import type {
  PaperJournalSummaryWindow,
  PaperJournalUploadSummary,
} from '@/app/types/paperJournal';

import styles from './PaperJournalSummaryCard.module.scss';

interface PaperJournalSummaryCardProps {
  summary: PaperJournalUploadSummary | null;
}

const WINDOW_LABELS: Record<PaperJournalSummaryWindow, string> = {
  '7d': 'Last 7 days',
  '30d': 'Last 30 days',
  '90d': 'Last 90 days',
  all: 'All time',
};

export const PaperJournalSummaryCard: React.FC<PaperJournalSummaryCardProps> = ({
  summary,
}) => {
  if (summary === null) {
    return null;
  }

  const windowLabel = WINDOW_LABELS[summary.window];

  return (
    <div className={styles.statsGrid}>
      <StatCard label={`Uploads (${windowLabel})`} value={summary.total_uploads} />
      <StatCard label={`Rows (${windowLabel})`} value={summary.total_rows} />
      <StatCard label={`Accepted (${windowLabel})`} value={summary.accepted_rows} />
      <StatCard label={`Rejected (${windowLabel})`} value={summary.rejected_rows} />
    </div>
  );
};

export default PaperJournalSummaryCard;
